import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";

import "./index.css";

import Layout from "./pages/layout/Layout";
import LayoutAdmin from "./pages/layout/LayoutAdmin";
import { InvalidIpPage, MultiDeviceNoticePage, BadRoutePage, SessionTimeoutPage, NotFoundPage } from "./pages/auth/ErrorPage";
import Chat from "./pages/chat/Chat";
import { AppStateProvider } from "./state/AppProvider";
import { 
    Users, AddUser, ModifyUser, ImportUsers, ResetPassword,
    Groups, AddGroup, ModifyGroup,
    Logmon,
    Upload, ListFiles, UpdateSystemPrompt, UpdateGroup, UpdateUserPromptExample, UpdateTags, UserPromptExample,
    Costs,
    OutputCSVAll,
    NGWordList, AddNGWord, ModifyNGWord,
    Functions, ModifyFunction,
    PromptTemplates, AddPromptTemplateCategory
} from "./pages/admin";
import LayoutSuperuser from "./pages/layout/LayoutSuperuser";
import { SuperuserCosts, SuperuserErrors, SuperuserStatistics } from "./pages/superuser";
import { ChangePassword } from "./pages/auth/ChangePassword";
import { LoginPage } from "./pages/auth/Login";

const EditPromptTemplate = lazy(() => import("./pages/prompt-template/EditPromptTemplate"));

initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/');

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                {/* 遅延読み込み */}
                <Route path="/edit_prompt_template/:id" element={
                    <Suspense fallback={<div>Loading...</div>}>
                        <EditPromptTemplate />
                    </Suspense>
                } />
                <Route path="/edit_prompt_template" element={
                    <Suspense fallback={<div>Loading...</div>}>
                        <EditPromptTemplate />
                    </Suspense>
                } />

                <Route path="/login/:mykey" element={<LoginPage />} />
                <Route path="/change_password/:mykey" element={<ChangePassword />} />

                <Route path="/user_prompt_example/:seq" element={<UserPromptExample />} />
                <Route path="/menu" element={<LayoutAdmin />}>
                    {/* ユーザー操作系 */}
                    <Route path="users" element={<Users />} />
                    <Route path="users/modify" element={<ModifyUser />} />
                    <Route path="users/import" element={<ImportUsers />} />
                    <Route path="users/reset_password" element={<ResetPassword />} />
                    <Route path="add_user" element={<AddUser />} />

                    <Route path="groups" element={<Groups />} />
                    <Route path="groups/add" element={<AddGroup />} />
                    <Route path="groups/modify" element={<ModifyGroup />} />

                    <Route path="logmon" element={<Logmon />} />

                    <Route path="upload" element={<Upload />} />
                    <Route path="upload/list_files/:container_seq" element={<ListFiles />} />
                    <Route path="upload/update_system_prompt/:seq" element={<UpdateSystemPrompt />} />
                    <Route path="upload/update_group/:seq" element={<UpdateGroup />} />
                    <Route path="upload/update_user_prompt_example/:seq" element={<UpdateUserPromptExample />} />
                    <Route path="upload/update_tags/:seq" element={<UpdateTags />} />


                    <Route path="costs" element={<Costs />} />

                    <Route path="outputcsvall" element={<OutputCSVAll />} />

                    <Route path="ngwordslist" element={<NGWordList />} />
                    <Route path="ngwordslist/add" element={<AddNGWord />} />
                    <Route path="ngwordslist/modify" element={<ModifyNGWord />} />

                    <Route path="functions" element={<Functions />} />
                    <Route path="functions/modify" element={<ModifyFunction />} />
                    
                    <Route path="prompt_templates_list" element={<PromptTemplates />} />
                    <Route path="prompt_templates_list/add_category" element={<AddPromptTemplateCategory />} />
                </Route>

                <Route path="/superuser" element={<LayoutSuperuser />}>
                    <Route path="statistics" element={<SuperuserStatistics />} />
                    <Route path="error" element={<SuperuserErrors />} />
                    <Route path="costs" element={<SuperuserCosts />} />
                </Route>
                
                <Route path="/" element={
                    <AppStateProvider>
                        <Layout />
                    </AppStateProvider>
                }>
                    <Route index element={<Chat />} />
                    <Route path="chat/:conversationId" element={<Chat />} />
                </Route>
                
                <Route path="/badroute" element={<BadRoutePage />} />
                <Route path="/session_timeout" element={<SessionTimeoutPage />} />
                <Route path="/multi_device_notice" element={<MultiDeviceNoticePage />} />
                <Route path="/invalid_ip" element={<InvalidIpPage />} />
                <Route path="*" element={<NotFoundPage />} />
                
            </Routes>
        </BrowserRouter>
    );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <App />
);
